import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import "./_style.scss";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import {CircleButton, Popover} from "Ncontracts.Common.UI";
import {CommunicationModel} from "../../Models/communications/communicationModel";
import {
    deleteCommunication,
    dismissErrorAlert,
    dissociateCommunicationEvent,
    saveEventAssociation,
    sendCommunication,
    SET_SELECTED_EVENT_ID
} from "../../actions/communications/communicationsAction";
import isEmpty from "../../helpers/isEmpty";
import {ReactSVG} from "react-svg";
import ErrorAlert from "../common/ErrorAlert";
import DeletePrompt from "../common/DeletePrompt";
import AssociateEventModal from "./AssociateEventModal";

class CommunicationDetailHeader extends Component {

    static propTypes = {
        communication: PropTypes.shape(CommunicationModel),
        deleteCommunication: PropTypes.func,
        dismissError: PropTypes.func,
        history: PropTypes.object,
        isLoadingOverlayShowing: PropTypes.bool,
        saveEventAssociation: PropTypes.func,
        sendCommunication: PropTypes.func,
        setSelectedEventId: PropTypes.func,
        showErrorAlert: PropTypes.bool,
        submitEventDissociation: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            showAssociateEventModal: false,
            showDeletePrompt: false,
            showDissociateEventModal: false,
            showPopover: false,
        };
    }

    handleSendLinkClick = () => {
        this.props.sendCommunication(this.props.communication.id);
    };

    saveEventAssociation = () => {
        this.setState({...this.state, showAssociateEventModal: false});
        this.props.saveEventAssociation(this.props.communication.id, this.props.communication.selectedEventId);
    };

    submitEventDissociation = () => {
        this.setState({...this.state, showDissociateEventModal: false});
        this.props.submitEventDissociation(this.props.communication.id);
    };

    discardEventAssociation = () => {
        this.props.setSelectedEventId(null);
        this.setState({...this.state, showAssociateEventModal: false});
    };

    discardEventDissociation = () => {
        this.setState({...this.state, showDissociateEventModal: false});
    };

    deleteCommunication = () => {
        this.setState({...this.state, showDeletePrompt: false});
        this.props.deleteCommunication(this.props.communication.id);
    };

    render() {
        const {communication, dismissError, showErrorAlert} = this.props;
        const {title, status, dateCreatedString, sentDateString, creatorName, associatedEvent, availableEvents} = communication;

        const sendLink = status === 'Sent' ? undefined :
            this.props.isLoadingOverlayShowing ?
                <div className="menu-item"><a>Send</a></div> :
                <div className="menu-item" onClick={this.handleSendLinkClick}><a>Send</a></div>;

        const associateEventLink = isEmpty(availableEvents) || !isEmpty(associatedEvent) ? undefined :
            this.props.isLoadingOverlayShowing ?
                <div className="menu-item"><a>Associate Event</a></div> :
                <div className="menu-item" onClick={e => {
                    e.stopPropagation();
                    this.setState({...this.state, showAssociateEventModal: true, showPopover: false});
                }}><a>Associate Event</a></div>;

        const dissociateEventLink = isEmpty(associatedEvent) ? undefined :
            this.props.isLoadingOverlayShowing ?
                <div className="menu-item"><a>Dissociate Event</a></div> :
                <div className="menu-item" onClick={e => {
                    e.stopPropagation();
                    this.setState({...this.state, showDissociateEventModal: true, showPopover: false});
                }}><a>Dissociate Event</a></div>;

        const deleteLink = this.props.isLoadingOverlayShowing ?
            <div className="menu-item delete-link"><a>Delete</a></div> :
            <div className="menu-item delete-link" onClick={e => {
                e.stopPropagation();
                this.setState({...this.state, showDeletePrompt: true, showPopover: false});
            }}><a>Delete</a></div>;

        const popoverMenu =
            <div className="page-header-buttons">
                <CircleButton className="popover-container" isOpen={this.state.showPopover}
                              onClick={() => this.setState({...this.state, showPopover: !this.state.showPopover})}>
                    <ReactSVG className="ellipsis-svg" src={imageCdnUrls.ellipsis}/>
                    <Popover showPopover={this.state.showPopover} caretPosition="top-right" slideDirection="slide-down"
                             leftOffset="-165px" bottomOffset="null">
                        <div className="popover-menu">
                            {sendLink}
                            {associateEventLink}
                            {dissociateEventLink}
                            {deleteLink}
                        </div>
                    </Popover>
                </CircleButton>
            </div>;

        const senderText = status === 'Sent' ?
            <>Sent{isEmpty(creatorName) ? '' : <> by <span className="sender-name">{creatorName}</span></>} on {sentDateString}</> :
            <>Saved{isEmpty(creatorName) ? '' : <> by <span className="sender-name">{creatorName}</span></>} on {dateCreatedString}</>;

        const associatedEventSubtitle = isEmpty(associatedEvent) ? undefined :
            <div className="page-subtitle">
                <div className="img-with-text">
                    <img src={imageCdnUrls.comm_associate_event} width="20" height="21"/>
                    <div className="sent-by"><span className="sender-name">Associated Event:</span> {associatedEvent.title}</div>
                </div>
            </div>;

        return (<>
            <div className="back-link">
                <a onClick={() => this.props.history.push('/communications')}>
                    <img src={imageCdnUrls.back_arrow} width="6" height="6"/> Back to Communication List
                </a>
            </div>
            <div className="page-title-row">
                <div className="page-title">{title}</div>
                <div className="title-right">
                    <div className={`status-pill ${status.toLowerCase()}`}>{status}</div>
                    {popoverMenu}
                </div>
            </div>
            <div className="page-subtitle">
                <div className="img-with-text">
                    <img src={imageCdnUrls.date_picker} width="20" height="21"/>
                    <div className="sent-by">{senderText}</div>
                </div>
            </div>
            {associatedEventSubtitle}
            {(showErrorAlert) ? <ErrorAlert dismissHandler={dismissError}/> : undefined}
            <AssociateEventModal isActive={this.state.showAssociateEventModal} events={availableEvents}
                          discardButtonHandler={this.discardEventAssociation}
                          saveButtonHandler={this.saveEventAssociation}/>
            <DeletePrompt isActive={this.state.showDeletePrompt}
                          cancelButtonHandler={() => this.setState({...this.state, showDeletePrompt: false})}
                          deleteButtonHandler={this.deleteCommunication}/>
            {isEmpty(associatedEvent) ? undefined :
                <DeletePrompt message={`${associatedEvent.title} will no longer be associated with this Communication`}
                              isActive={this.state.showDissociateEventModal}
                              cancelButtonHandler={this.discardEventDissociation}
                              deleteButtonHandler={this.submitEventDissociation}/>
            }
        </>);
    }
}

const mapStateToProps = state => ({
    communication: state.communications.selectedCommunication,
    isLoadingOverlayShowing: state.communications.posting,
    showErrorAlert: state.communications.showErrorAlert,
});

const mapDispatchToProps = dispatch => ({
    deleteCommunication: id => dispatch(deleteCommunication(id)),
    dismissError: () => dispatch(dismissErrorAlert()),
    saveEventAssociation: (commId, eventId) => dispatch(saveEventAssociation(commId, eventId)),
    sendCommunication: id => dispatch(sendCommunication(id)),
    setSelectedEventId: id => dispatch({type: SET_SELECTED_EVENT_ID, eventId: id}),
    submitEventDissociation: id => dispatch(dissociateCommunicationEvent(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommunicationDetailHeader));
